import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import RequireAuth from './components/RequireAuth';
import SignIn from './pages/SignIn';
import Users from './pages/Users';
import Tasks from './pages/Tasks';
import Categories from './pages/Categories';
import { auth } from './firebase';

function App() {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      setUser(u);
      setInitializing(false);
    });
    return () => unsub();
  }, []);

  return (
    <Router>
      <div className="App">
        {initializing ? (
          <div className="container" style={{ padding: '48px 0' }}>
            <div className="loading-screen" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}>
              <div className="loading-card" style={{ background: 'rgba(255,255,255,0.92)', border: '1px solid rgba(0,0,0,0.08)', borderRadius: 16, boxShadow: '0 12px 32px rgba(0,0,0,0.10)', padding: '18px 22px', display: 'grid', gap: 10, placeItems: 'center' }}>
                <div className="spinner" style={{ width: 28, height: 28, border: '3px solid rgba(0,0,0,0.12)', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 0.9s linear infinite' }} />
                <div style={{ fontWeight: 700 }}>Loading admin…</div>
                <div style={{ fontSize: 13, color: '#667' }}>Checking session and preparing dashboard</div>
              </div>
            </div>
          </div>
        ) : (
          <Routes>
            <Route path="/" element={<Navigate to={user ? '/users' : '/signin'} replace />} />
            <Route path="/signin" element={<SignIn />} />
            <Route
              path="/users"
              element={
                <RequireAuth user={user}>
                  <Users />
                </RequireAuth>
              }
            />
            <Route
              path="/tasks"
              element={
                <RequireAuth user={user}>
                  <Tasks />
                </RequireAuth>
              }
            />
            {/* Ungated Categories for temporary public read bypass */}
            <Route
              path="/categories"
              element={
                <RequireAuth user={user}>
                  <Categories />
                </RequireAuth>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
